import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';
import refrigeratorType from 'constants/refrigeratorType';

const BodyType = observer(({ bodyType, brand }) => {
  const {
    dictionariesStore: { body_types },
  } = useStores();

  if (!bodyType) return null;

  const isRefrigerator = String(refrigeratorType) === String(bodyType);
  const refrigeratorBrand = isRefrigerator && brand && ` (${brand.name})`;

  return (
    <tr>
      <td className="pale">Кузов</td>
      <td>
        {body_types?.[bodyType]}
        {refrigeratorBrand}
      </td>
    </tr>
  );
});

export default BodyType;
